import Flex from 'antd/es/flex';
import Modal from 'antd/es/modal/Modal';
import { FC } from 'react';
import { Divider } from 'antd';
import { TenderTotalAmountResponse } from '@Types/api/form/tenderRequest/TenderTotalAmountResponse';

import { List } from '../../../common/List';

export interface PriceBreakdownDesktopProps {
  onClose: () => void;
  total: TenderTotalAmountResponse;
}

const PriceBreakdownDesktop: FC<PriceBreakdownDesktopProps> = ({
  total,
  onClose,
}) => {
  return (
    <Modal open title="Price Breakdown" onCancel={onClose} footer={null}>
      <Divider />
      <Flex vertical gap="16px">
        <List>
          <List.Item
            title="Total Amount (Without Tax)"
            value={String(total.totalAmountWithoutTax)}
          />
          <List.Item title="Tax" value={String(total.totalTax || 0)} />
          <List.Item
            title="Total Amount (With Tax)"
            value={String(total.totalAmountWithTax || 0)}
          />
          <List.Item
            title="Final Amount"
            value={String(total.finalTotAmount || 0)}
            strong
          />
        </List>
      </Flex>
    </Modal>
  );
};

export default PriceBreakdownDesktop;
